module.exports = __webpack_public_path__ + "mo/img/piece-08.4dc36a2b.svg";